<script lang="ts" setup>
import type { Player, Team } from '~/types'

interface Props {
  team: Team.Model
  player: Player.Model
}

const props = defineProps<Props>()
const {
  biography,
  previousExperience,
  previousExperienceTitle,
} = usePlayer(props.player)
</script>

<template>
  <div class="player-bio-page">
    <Wrapper>
      <div class="player-bio-page__content">
        <div
          v-if="biography"
          class="player-bio-page__biography"
        >
          <UIEmbedHtml :content="biography" />
        </div>

        <div
          v-if="previousExperience"
          class="player-bio-page__previous-experience"
        >
          <UIDynamicHeading
            level="3"
            as="h4"
            class="player-bio-page__previous-experience-title"
          >
            {{ previousExperienceTitle }}
          </UIDynamicHeading>
          <div class="player-bio-page__previous-experience-content">
            <p v-text="previousExperience" />
          </div>
        </div>
      </div>
    </Wrapper>
  </div>
</template>

<style lang="scss" scoped>
.player-bio-page {
  @apply py-[30px];

  &__content {
    @apply px-0;
  }

  &__biography {
    @apply mb-[30px];
  }

  &__previous-experience {
    @apply mb-[30px];
  }

  &__previous-experience-title {
    @apply mb-[10px];
  }

  &__previous-experience-content {
    @apply text-[16px];
  }
}
</style>
